export function getUserPermissions() {
  try {
    const raw = localStorage.getItem('permissions');
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    return [];
  }
}

export function hasMenuPermission(menu, level = 'view') {
  const permissions = getUserPermissions();
  const entry = permissions.find((p) => p.menu === menu);
  if (!entry) return false;

  const canManage = entry.manage === 1 || entry.manage === true;
  const canView = entry.view === 1 || entry.view === true;

  if (level === 'manage') {
    return canManage;
  }

  return canView || canManage;
}
